import React from "react";
import { Link } from "react-router-dom";
import { Layout } from "../../layouts/Layout";
import {
  INNER_ABOUT_IMG03,
  INNER_CHOOSE_IMG,
} from "../../lib/assets";
import "./CompanySecretarialServices.css";

const serviceItems = [
  {
    title: "Corporate Governance Advisory",
    text: "Practical guidance for stronger governance frameworks, board processes, policies and corporate decision-making.",
  },
  {
    title: "ROC Compliance & Statutory Filings",
    text: "Preparation and filing of annual returns, financial statements, statutory forms and event-based ROC compliances.",
  },
  {
    title: "Secretarial Audit & Certification",
    text: "Independent compliance reviews, secretarial audits, due diligence and certifications by experienced professionals.",
  },
  {
    title: "Company Incorporation & Structuring",
    text: "End-to-end support for company and LLP incorporation, restructuring, amendments and statutory registrations.",
  },
  {
    title: "Board & Shareholder Documentation",
    text: "Notices, agendas, minutes, resolutions, attendance records and complete meeting documentation support.",
  },
  {
    title: "FEMA, RBI, NBFC & LLP Compliance",
    text: "Regulatory assistance for foreign investment, FEMA reporting, RBI requirements, NBFC and LLP compliance matters.",
  },
];

const processSteps = [
  {
    number: "01",
    title: "Consultation",
    text: "We understand your entity structure, business activities and immediate compliance priorities.",
  },
  {
    number: "02",
    title: "Compliance Assessment",
    text: "Our team reviews existing records, filings, registers and pending statutory obligations.",
  },
  {
    number: "03",
    title: "Documentation",
    text: "We prepare resolutions, registers, returns, certifications and supporting documents accurately.",
  },
  {
    number: "04",
    title: "Filing & Representation",
    text: "Required forms are filed and regulatory communication is professionally managed on your behalf.",
  },
  {
    number: "05",
    title: "Continuous Compliance",
    text: "A compliance calendar and periodic monitoring help keep your business compliant throughout the year.",
  },
];

const benefits = [
  "Timely statutory compliance",
  "Reduced legal and financial risks",
  "Strong corporate governance practices",
  "Professional board meeting management",
  "End-to-end ROC filing support",
  "Expert FEMA and RBI assistance",
  "Dedicated compliance monitoring",
  "Transparent and reliable advisory",
];

const faqs = [
  {
    question: "Who needs Company Secretarial Services?",
    answer:
      "Companies, LLPs, NBFCs, startups, foreign subsidiaries and other corporate entities that must meet statutory, governance and regulatory obligations can benefit from these services.",
  },
  {
    question: "Can Globiz India handle annual ROC filings?",
    answer:
      "Yes. We assist with annual returns, financial statement filings, director-related filings and other recurring ROC requirements.",
  },
  {
    question: "Do you support startups and newly incorporated companies?",
    answer:
      "Yes. We help startups with incorporation, post-incorporation compliances, board documentation, statutory registers and ongoing compliance calendars.",
  },
  {
    question: "Do you assist with FEMA and RBI compliance?",
    answer:
      "Yes. Our team supports eligible businesses with FEMA reporting, foreign investment compliance and relevant RBI-related documentation and filings.",
  },
];

const CheckIcon = () => (
  <svg viewBox="0 0 24 24" aria-hidden="true">
    <path d="M20 6 9 17l-5-5" fill="none" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round" />
  </svg>
);

const ArrowIcon = () => (
  <svg viewBox="0 0 24 24" aria-hidden="true">
    <path d="M5 12h14M13 6l6 6-6 6" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
  </svg>
);

const ServiceIcon = ({ index }) => {
  const icons = [
    <path key="1" d="M4 20h16M6 20V9m12 11V9M3 9h18L12 3 3 9Zm7 4h4m-4 3h4" />,
    <path key="2" d="M7 3h10l4 4v14H7V3Zm10 0v5h4M3 7v14h14" />,
    <path key="3" d="M12 3 4 6v5c0 5 3.4 8.4 8 10 4.6-1.6 8-5 8-10V6l-8-3Zm-3 9 2 2 4-4" />,
    <path key="4" d="M4 21V7l8-4 8 4v14M8 10h2m4 0h2M8 14h2m4 0h2M9 21v-3h6v3" />,
    <path key="5" d="M4 5h16v14H4V5Zm0 4h16M8 3v4m8-4v4M8 13h3m2 0h3m-8 3h3" />,
    <path key="6" d="M4 12a8 8 0 1 0 16 0 8 8 0 0 0-16 0Zm8-8c2 2.2 3 4.9 3 8s-1 5.8-3 8c-2-2.2-3-4.9-3-8s1-5.8 3-8ZM4.5 9h15M4.5 15h15" />,
  ];

  return (
    <svg viewBox="0 0 24 24" aria-hidden="true">
      <g fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
        {icons[index]}
      </g>
    </svg>
  );
};

const CompanySecretarialServices = () => {
  return (
    <Layout header={4} footer={2}
      breadcrumb={"Company Secretarial Services"}
      title={"Company Secretarial Services"}
    >
      <main className="css-page">
        <section className="css-intro section-space">
          <div className="container">
            <div className="row align-items-center g-5">
              <div className="col-lg-6 col-md-10 mx-auto">
                <div className="css-intro__visual">
                  <img
                    className="css-intro__main-image"
                    src={INNER_ABOUT_IMG03}
                    alt="Company secretarial services professionals"
                  />
                  <div className="css-intro__experience-card">
                    <strong>20+</strong>
                    <span>Years of practical compliance experience</span>
                  </div>
                
                </div>
              </div>

              <div className="col-lg-6">
                <div className="css-section-heading">
                  <span className="css-eyebrow">Corporate Compliance Solutions</span>
                  <h2>Reliable Secretarial Support for Stronger Corporate Governance</h2>
                </div>

                <p className="css-lead">
                  Keeping your business compliant with corporate laws is essential
                  for sustainable growth. At Globiz India, our Company Secretarial
                  Services help businesses meet statutory requirements while
                  maintaining high standards of governance.
                </p>
                <p>
                  Whether you are a startup, private limited company, LLP, NBFC or
                  multinational organization, our experienced professionals support
                  compliance under the Companies Act, FEMA regulations, SEBI
                  requirements and other applicable statutory obligations.
                </p>

                <div className="css-highlight-list">
                  <div className="css-highlight-item">
                    <span className="css-highlight-item__icon"><CheckIcon /></span>
                    <div>
                      <h4>Complete Compliance Management</h4>
                      <p>Recurring, annual and event-based filings managed accurately.</p>
                    </div>
                  </div>
                  <div className="css-highlight-item">
                    <span className="css-highlight-item__icon"><CheckIcon /></span>
                    <div>
                      <h4>Governance-Focused Advisory</h4>
                      <p>Practical guidance aligned with your business structure and goals.</p>
                    </div>
                  </div>
                </div>

                <div className="css-intro__actions">
                  <Link to="/contact" className="css-btn css-btn--primary">
                    Discuss Your Compliance Needs <ArrowIcon />
                  </Link>
                  <div className="css-trust-note">
                    <strong>98%</strong>
                    <span>Compliance accuracy focus</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>

        <section className="css-speciality">
          <div className="container-fluid p-0">
            <div className="row g-0 align-items-stretch">
              <div className="col-lg-6 css-speciality__content-col">
                <div className="css-speciality__content">
                  <span className="css-eyebrow css-eyebrow--light">What We Cover</span>
                  <h2>End-to-End Company Secretarial Services</h2>
                  <p>
                    From incorporation and statutory records to annual filings,
                    board processes and regulatory reporting, we help your business
                    remain organised, compliant and audit-ready.
                  </p>

                  <div className="accordion css-accordion" id="secretarialAccordion">
                    <div className="accordion-item">
                      <h3 className="accordion-header">
                        <button
                          className="accordion-button"
                          type="button"
                          data-bs-toggle="collapse"
                          data-bs-target="#secretarialOne"
                          aria-expanded="true"
                          aria-controls="secretarialOne"
                        >
                          ROC, Annual and Event-Based Compliance
                        </button>
                      </h3>
                      <div
                        id="secretarialOne"
                        className="accordion-collapse collapse show"
                        data-bs-parent="#secretarialAccordion"
                      >
                        <div className="accordion-body">
                          Annual returns, financial statement filings, director
                          filings, resolutions and statutory forms are prepared and
                          filed within applicable timelines.
                        </div>
                      </div>
                    </div>

                    <div className="accordion-item">
                      <h3 className="accordion-header">
                        <button
                          className="accordion-button collapsed"
                          type="button"
                          data-bs-toggle="collapse"
                          data-bs-target="#secretarialTwo"
                          aria-expanded="false"
                          aria-controls="secretarialTwo"
                        >
                          Board, Shareholder and Statutory Records
                        </button>
                      </h3>
                      <div
                        id="secretarialTwo"
                        className="accordion-collapse collapse"
                        data-bs-parent="#secretarialAccordion"
                      >
                        <div className="accordion-body">
                          We support notices, agendas, minutes, resolutions,
                          attendance records, statutory registers and related meeting
                          documentation.
                        </div>
                      </div>
                    </div>

                    <div className="accordion-item">
                      <h3 className="accordion-header">
                        <button
                          className="accordion-button collapsed"
                          type="button"
                          data-bs-toggle="collapse"
                          data-bs-target="#secretarialThree"
                          aria-expanded="false"
                          aria-controls="secretarialThree"
                        >
                          FEMA, RBI, NBFC and LLP Support
                        </button>
                      </h3>
                      <div
                        id="secretarialThree"
                        className="accordion-collapse collapse"
                        data-bs-parent="#secretarialAccordion"
                      >
                        <div className="accordion-body">
                          Our team assists with applicable foreign investment,
                          regulatory reporting, NBFC compliance and LLP statutory
                          requirements.
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div className="col-lg-6 css-speciality__image-col">
                <img
                  src={INNER_CHOOSE_IMG}
                  alt="Corporate team reviewing statutory compliance"
                />
                <div className="css-speciality__image-overlay">
                  <span>Reliable. Timely. Transparent.</span>
                  <strong>Compliance that supports business growth.</strong>
                </div>
              </div>
            </div>
          </div>
        </section>

        <section className="css-services section-space">
          <div className="container">
            <div className="css-section-heading css-section-heading--center">
              <span className="css-eyebrow">Key Features</span>
              <h2>Comprehensive Corporate Secretarial Support</h2>
              <p>
                Flexible compliance solutions tailored to the nature, scale and
                regulatory requirements of your organisation.
              </p>
            </div>

            <div className="row g-4">
              {serviceItems.map((item, index) => (
                <div className="col-lg-4 col-md-6" key={item.title}>
                  <article className="css-service-card">
                    <div className="css-service-card__icon">
                      <ServiceIcon index={index} />
                    </div>
                    <h3>{item.title}</h3>
                    <p>{item.text}</p>
                    <Link to="/contact" className="css-text-link">
                      Get expert support <ArrowIcon />
                    </Link>
                  </article>
                </div>
              ))}
            </div>
          </div>
        </section>

        <section className="css-benefits section-space">
          <div className="container">
            <div className="row align-items-center g-5">
              <div className="col-lg-5">
                <div className="css-section-heading">
                  <span className="css-eyebrow">Why Choose Globiz India</span>
                  <h2>Regulatory Knowledge with Practical Business Understanding</h2>
                </div>
                <p>
                  Our team combines technical expertise, disciplined execution and
                  clear communication to deliver accurate, timely and cost-effective
                  compliance solutions.
                </p>
                <Link to="/contact" className="css-btn css-btn--dark">
                  Speak with Our Experts <ArrowIcon />
                </Link>
              </div>

              <div className="col-lg-7">
                <div className="css-benefits__grid">
                  {benefits.map((benefit) => (
                    <div className="css-benefit-item" key={benefit}>
                      <span><CheckIcon /></span>
                      <p>{benefit}</p>
                    </div>
                  ))}
                </div>
              </div>
            </div>
          </div>
        </section>

        <section className="css-process section-space">
          <div className="container">
            <div className="css-section-heading css-section-heading--center">
              <span className="css-eyebrow">Our Process</span>
              <h2>A Structured Approach to Continuous Compliance</h2>
            </div>

            <div className="css-process__track">
              {processSteps.map((step) => (
                <article className="css-process-card" key={step.number}>
                  <span className="css-process-card__number">{step.number}</span>
                  <h3>{step.title}</h3>
                  <p>{step.text}</p>
                </article>
              ))}
            </div>
          </div>
        </section>

        <section className="css-faq section-space">
          <div className="container">
            <div className="row g-5 align-items-start">
              <div className="col-lg-5">
                <div className="css-section-heading">
                  <span className="css-eyebrow">Frequently Asked Questions</span>
                  <h2>Clear Answers for Your Compliance Requirements</h2>
                </div>
                <p>
                  Have a requirement not covered here? Our team can review your
                  entity and recommend a suitable compliance scope.
                </p>
                <Link to="/contact" className="css-btn css-btn--primary">
                  Ask Our Experts <ArrowIcon />
                </Link>
              </div>

              <div className="col-lg-7">
                <div className="accordion css-faq__accordion" id="secretarialFaq">
                  {faqs.map((faq, index) => {
                    const collapseId = `secretarialFaq${index + 1}`;
                    return (
                      <div className="accordion-item" key={faq.question}>
                        <h3 className="accordion-header">
                          <button
                            className={`accordion-button ${index === 0 ? "" : "collapsed"}`}
                            type="button"
                            data-bs-toggle="collapse"
                            data-bs-target={`#${collapseId}`}
                            aria-expanded={index === 0 ? "true" : "false"}
                            aria-controls={collapseId}
                          >
                            {faq.question}
                          </button>
                        </h3>
                        <div
                          id={collapseId}
                          className={`accordion-collapse collapse ${index === 0 ? "show" : ""}`}
                          data-bs-parent="#secretarialFaq"
                        >
                          <div className="accordion-body">{faq.answer}</div>
                        </div>
                      </div>
                    );
                  })}
                </div>
              </div>
            </div>
          </div>
        </section>

        <section className="css-cta">
          <div className="container">
            <div className="css-cta__inner">
              <div>
                <span className="css-eyebrow css-eyebrow--light">Stay Compliant. Grow Confidently.</span>
                <h2>Need dependable Company Secretarial support?</h2>
                <p>
                  Let Globiz India manage your statutory obligations while you focus
                  on building and growing your business.
                </p>
              </div>
              <Link to="/contact" className="css-btn css-btn--white">
                Request a Consultation <ArrowIcon />
              </Link>
            </div>
          </div>
        </section>
      </main>
    </Layout>
  );
};

export default CompanySecretarialServices;
